/*
 * @Description: 数据字典
 * @Author: lijinpeng
 * @Date: 2022-10-09 16:47:57
 * @LastEditTime: 2024-03-15 18:31:02
 * @LastEditors: lijinpeng
 */
export const cargo = [
  { label: '装货量', value: '装货量' },
  { label: '卸货量', value: '卸货量' },
  { label: '较小值', value: '较小值' },
];

export const other = [
  { label: '保险', value: '保险' },
  { label: '装车费', value: '装车费' },
  { label: '其他', value: '其他' },
];

export const oilType = [
  { label: '%', value: 0 },
  { label: '元', value: 1 },
];

// 运费支付方式
export const payTypeList = [
  { label: '司机', value: '1' },
  { label: '经纪人', value: '2' },
];

// 定价方式
export const priceTypeList = [
  { label: '协商定价', value: '1' },
  { label: '按货量定价', value: '2' },
];

// 用户角色
export const roleTypes = [
  { label: '系统管理员', value: 'SUPER_ADMIN' },
  { label: '超级财务', value: 'SUPER_FINANCE' },
  { label: '普通财务', value: 'NORMAL_FINANCE' },
  { label: '外调车调度', value: 'NORMAL' },
  { label: '自有车调度', value: 'NORMAL_ZY' },
];

// 网络货运平台列表
export const channelInfos = [
  { label: '湖北我家物流服务有限公司', value: 'hubeiwojia' },
  { label: '安徽我家物流服务有限公司', value: 'anhuiwojia' },
  { label: '安徽省徽商登峰物流科技有限公司', value: 'dengfenghuishang' },
  { label: '湖北赢路物流有限公司安陆分公司', value: 'anluwojia' },
  { label: '淮安市翔和翎物流有限公司', value: 'xiangheling' },
  { label: '安徽省徽商登峰物流科技有限公司芜湖市分公司', value: 'wuhuhuishang' },
  { label: '华米互联网科技（济南）有限公司青岛分公司', value: 'huami' },
  { label: '安徽省徽商物流有限公司', value: 'huishang' },
  { label: '安徽神通物流集团有限公司', value: 'shentongwuliananhui' },
  { label: '成丰网络货运平台', value: 'chengfeng' },
];

// 燃料类型
export const fuelTypes = [
  { value: '1', label: '汽油' },
  { value: '2', label: '柴油' },
  { value: '3', label: '天然气' },
];

// 载货长度
export const extent = [
  { label: '18.5', value: '18.5' },
  { label: '17.5', value: '17.5' },
  { label: '16', value: '16' },
  { label: '15', value: '15' },
  { label: '13.7', value: '13.7' },
  { label: '13', value: '13' },
  { label: '12.5', value: '12.5' },
  { label: '11.7', value: '11.7' },
  { label: '9.6', value: '9.6' },
  { label: '8.7', value: '8.7' },
  { label: '8.2', value: '8.2' },
  { label: '7.7', value: '7.7' },
  { label: '6.8', value: '6.8' },
  { label: '6.2', value: '6.2' },
  { label: '5', value: '5' },
  { label: '4.2', value: '4.2' },
  { label: '3.8', value: '3.8' },
  { label: '2.7', value: '2.7' },
  { label: '1.8', value: '1.8' },
  { label: '1.6', value: '1.6' },
  { label: '1.4', value: '1.4' },
];

// 角色权限
export const roleType = [
  { value: 'SUPER_ADMIN', label: '系统管理员' },
  { value: 'NORMAL_FINANCE', label: '普通财务' },
  { value: 'SUPER_FINANCE', label: '超级财务' },
  { value: 'NORMAL', label: '调度员' },
];

// 数据权限
export const dataPermissionTypes = [
  { value: 'GROUP', label: '集团' },
  { value: 'PROJECT', label: '项目' },
  { value: 'PERSONAL', label: '个人' },
];
